import { render, staticRenderFns } from "./PaymentMethodsErrors.vue?vue&type=template&id=8b2172d2&"
import script from "./PaymentMethodsErrors.vue?vue&type=script&setup=true&lang=js&"
export * from "./PaymentMethodsErrors.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports